/* tlr-conversion.js — barra de envío gratis y guía de tallas.

   Dos piezas sueltas, cada una arranca sola. Si una no encuentra su
   HTML, se va sin hacer ruido: así este archivo puede cargarse en
   todas las páginas sin costo. */
(function () {
  "use strict";

  /* ── Plata ────────────────────────────────────────────────────
     Shopify entrega los montos en céntimos. En colones nadie escribe
     los decimales, así que se redondea y se separan los miles con
     punto, igual que en el resto de la tienda. */
  function colones(centimos) {
    var n = Math.round(Number(centimos) / 100);
    return "₡" + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  /* ══ 1 · Barra de envío gratis ════════════════════════════════
     El Liquid ya dibuja la barra con el total correcto al cargar la
     página; esto la vuelve a calcular sin recargar cuando el carrito
     cambia. Se refresca en tres momentos: al arrancar, cuando algo
     dispara el evento tlr:carrito, y cuando la persona vuelve a la
     pestaña (pudo haber agregado algo desde otra). */
  (function () {
    var barra = document.querySelector("[data-envio]");
    if (!barra) { return; }

    var meta   = Number(barra.getAttribute("data-meta")) || 0;
    var riel   = barra.querySelector("[data-envio-relleno]");
    var texto  = barra.querySelector("[data-envio-texto]");
    if (!meta || !riel || !texto) { return; }

    function pintar(total) {
      var falta = meta - total;
      var pct = Math.max(0, Math.min(100, (total / meta) * 100));
      riel.style.setProperty("--avance", pct.toFixed(1) + "%");

      if (falta <= 0) {
        barra.classList.add("es-listo");
        texto.innerHTML = "¡Listo! Tu envío va <b>gratis</b> con Correos de Costa Rica.";
      } else {
        barra.classList.remove("es-listo");
        texto.innerHTML = "Te faltan <b>" + colones(falta) +
          "</b> para el envío gratis a todo el país.";
      }
      barra.setAttribute("aria-valuenow", Math.round(pct));
    }

    function releer() {
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c) { pintar(c.total_price); } })
        .catch(function () { /* se queda con lo que pintó Liquid */ });
    }

    /* Primer pintado desde el atributo, sin esperar la red. */
    pintar(Number(barra.getAttribute("data-total")) || 0);

    releer();
    document.addEventListener("tlr:carrito", releer);
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) { releer(); }
    });
  })();

  /* ══ 2 · Guía de tallas ═════════════════════════════════════
     Dos paneles, Fan y Player. Cambian de tres formas: por las
     pestañas, y solos cuando la persona elige una versión arriba en
     la ficha — que es el caso que importa, porque así la tabla
     siempre muestra la talla del producto que se va a llevar. */
  (function () {
    var guia = document.querySelector("[data-guia]");
    if (!guia) { return; }

    var tabs    = guia.querySelectorAll("[data-guia-tab]");
    var paneles = guia.querySelectorAll("[data-guia-panel]");
    if (!tabs.length) { return; }

    function mostrar(cual) {
      var hay = false;
      Array.prototype.forEach.call(paneles, function (p) {
        var mio = p.getAttribute("data-guia-panel") === cual;
        p.hidden = !mio;
        if (mio) { hay = true; }
      });
      if (!hay) { return; }
      Array.prototype.forEach.call(tabs, function (t) {
        t.setAttribute("aria-pressed", String(t.getAttribute("data-guia-tab") === cual));
      });
    }

    guia.addEventListener("click", function (ev) {
      var t = ev.target.closest("[data-guia-tab]");
      if (t) { mostrar(t.getAttribute("data-guia-tab")); }
    });

    /* Los chips de versión de la ficha son botones .chip con data-val.
       Escuchamos en el documento y filtramos por valor: si dice Fan o
       Player, la tabla lo sigue. Cualquier otro chip (la talla, por
       ejemplo) no la toca. */
    document.addEventListener("click", function (ev) {
      var chip = ev.target.closest(".chip[data-val]");
      if (!chip) { return; }
      var v = (chip.getAttribute("data-val") || "").toLowerCase();
      if (v === "fan" || v === "player") { mostrar(v); }
    });

    /* Arranque: si la ficha ya viene con una versión marcada, esa
       manda; si no, el primer panel que exista. */
    var marcado = document.querySelector(".chip[aria-pressed='true'][data-val]");
    var inicial = marcado ? (marcado.getAttribute("data-val") || "").toLowerCase() : "";
    if (inicial !== "fan" && inicial !== "player") {
      inicial = paneles.length ? paneles[0].getAttribute("data-guia-panel") : "fan";
    }
    mostrar(inicial);
  })();
})();
